import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManualHeaderPageRoutingModule } from './manual-header-routing.module';

import { ManualHeaderPage } from './manual-header.page';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MatButtonModule,
    ManualHeaderPageRoutingModule,
    MatMenuModule,
    MatTooltipModule
  ],
  declarations: [ManualHeaderPage],
  exports: [
    ManualHeaderPage
  ],
})
export class ManualHeaderPageModule {}
